// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"89":"36485471","760":"18b0ade9"}[chunkId] + ".chunk.css";
};